<template>
  <v-container :class="[
    'customer-tracking-form',
    {'customer-tracking-form--dark': dark},
    {'customer-tracking-form--light': !dark},
  ]">
    <v-layout column>
      <v-flex>
        <v-layout row align-center justify-space-between>
          <v-flex>
            <header>
              <h4 :class="{'text-white': dark, 'text-black': !dark}">CREAR SEGUIMIENTO</h4>
            </header>
          </v-flex>
          <v-flex>
            <v-layout row justify-end>
              <button @click="close">
                <v-icon :color="dark ? 'white' : 'black'">close</v-icon>
              </button>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mt-2>
        <v-layout row>
          <v-flex xs6>
            <v-menu
              ref="date"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="form.date"
              transition="scale-transition"
              min-width="290px"
              lazy
              offset-y
              full-width>
              <v-text-field
                :value="formatDateV2(form.date, 'YYYY-MM-DD', 'DD/MM/YYYY')"
                :error-messages="errors.collect('customerTrackingForm.date')"
                slot="activator"
                class="k-orange-linear-text"
                label="Fecha"
                v-validate="'required'"
                data-vv-name="date"
                data-vv-as="fecha"
                data-vv-scope="customerTrackingForm"
                readonly
                solo
              />
              <v-date-picker
                v-model="form.date"
                @input="$refs.date.save(form.date)"
                locale="es"
                color="k-orange-linear"
              />
            </v-menu>
          </v-flex>
          <v-flex xs6 ml-2>
            <v-select
              v-model="form.hour"
              :items="hours"
              :error-messages="errors.collect('customerTrackingForm.hour')"
              label="Hora"
              item-text="displayHour"
              item-value="hour"
              color="black"
              v-validate="'required'"
              data-vv-name="hour"
              data-vv-as="hora"
              data-vv-scope="customerTrackingForm"
              autocomplete
              solo
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mt-2>
        <v-select
          v-model="form.channel_id"
          :items="channels"
          :error-messages="errors.collect('customerTrackingForm.channel')"
          label="Canal"
          item-text="name"
          item-value="id"
          color="black"
          v-validate="'required'"
          data-vv-name="channel"
          data-vv-as="día"
          data-vv-scope="customerTrackingForm"
          autocomplete
          solo
        />
      </v-flex>
      <v-flex mt-2>
        <textarea
          v-model="form.justification"
          :class="['customer-tracking-form__justification', {'has-error--solo': errors.has('customerTrackingForm.justification')}]"
          type="text"
          rows="2"
          placeholder="Razón"
          color="black"
          v-validate="'required'"
          data-vv-name="justification"
          data-vv-as="Razón"
          data-vv-scope="customerTrackingForm"
          solo
        />
      </v-flex>
      <v-flex mt-2>
        <v-layout row align-center justify-end>
          <v-btn class="k-orange-linear white--text" large @click="save" :disabled="isLoading">
            <span>GUARDAR</span>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment';
import EventBus from '@/event-bus';
import FormatDateMixin from '@/mixins/formatDate';

export default {
  inject: ['$validator'],
  mixins: [
    FormatDateMixin,
  ],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: true,
    },
    customerId: {
      type: Number,
      required: false,
    },
    channelId: {
      type: Number,
      required: false,
    },
    contact: {
      type: String,
      required: false,
    },
    customerName: {
      type: String,
      required: false,
    },
    customerAccount: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.$validator.reset();
  },
  destroyed() {
    this.clearForm();
  },
  data() {
    return {
      isLoading: false,
      channels: [
        {
          id: 1,
          name: 'Email',
        },
        {
          id: 2,
          name: 'SMS',
        },
        {
          id: 5,
          name: 'Humano',
        },
        {
          id: 7,
          name: 'WhatsApp',
        },
      ],
      form: {
        date: '',
        hour: '',
        channel_id: null,
        justification: '',
        channelName: '',
        customerName: '',
        customerAccount: '',
      },
    };
  },
  computed: {
    hours() {
      let list = [];
      for (let i = 6; i <= 20; i += 1) {
        for (let j = 0; j <= 45; j += 15 ) {
          let hour = `${i}:${ j === 0 ? '00': j }`;
          list.push(hour);
        }
      }
      return list.map((hour, index) => ({
        id: index + 1,
        hour: `${hour}:00`,
        displayHour: moment(hour, 'HH:mm').format('hh:mm A'),
      }));
    },
  },
  methods: {
    close() {
      this.$emit('close');
      this.$emit('input', false);
    },
    clearForm() {
      this.$validator.reset();
      this.form = {
        date: '',
        hour: '',
        channel_id: null,
        justification: '',
      };
    },
    save() {
      this.$validator
        .validateAll('customerTrackingForm')
        .then((validation) => {
          if (validation) {
            this.isLoading = true;
            this.axios.post('customers_tracking', {
              customer_id: this.customerId,
              contact: this.contact,
              ...this.form,
              channel_name: this.channels.find(
                channel => channel.id === this.form.channel_id
              ).name || 'Humano',
              customer_name: this.customerName,
              customer_account: this.customerAccount,
            })
              .then(({ data }) => {
                this.$emit('save', data);
                this.close();
              })
              .catch(() => {
                EventBus.$emit('modal', 'Ya existe un seguimiento para el cliente en el canal seleccionado');
              })
              .finally(() => {
                this.isLoading = false
              });
          }
        });
    },
  },
  watch: {
    value() {
      if (!this.isLoading) {
        this.clearForm();
      }
      if (this.channelId) {
        this.form.channel_id = this.channelId;
      }
    },
  },
};
</script>

<style scoped>
.customer-tracking-form {
  width: 400px;
  height: 325px;
}
.customer-tracking-form--dark {
  background-color: rgba(38, 50, 56, 0.76) !important;
}
.customer-tracking-form--light {
  background-color: #FFFFFF !important;
}
.customer-tracking-form__justification {
  height: 60px;
}
.customer-tracking-form__justification::placeholder {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerTrackingForm.vue